import React, { useState, useRef, useEffect } from 'react';
import "./home.scss";
import { Container, Row, Col } from "react-bootstrap";
import { FaQuestionCircle, FaWhatsapp } from 'react-icons/fa';
import { Link } from "react-router-dom";
import Services from '../../components/services';
import ProjectsSlider from '../../components/projectSlider/projectsSlider';
import LetsTalk from '../../components/letsTalk/letsTalk';
import BookForm from '../../components/bookform/bookform';
import GlitchLines from '../../components/glitchLines/glitchLines';
import { useAnimationContext } from '../../AnimationContext';
//import useFetch from '../../useFetch';
import { gsap } from 'gsap';
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Home = () => {
    const { isPreloaderComplete } = useAnimationContext();

    //for glitch lines
    const parentRef = useRef(null);

    // State to manage Offcanvas visibility
    const [showOffcanvas, setShowOffcanvas] = useState(false);

    // Function to toggle Offcanvas visibility
    const toggleOffcanvas = () => setShowOffcanvas(!showOffcanvas);

/*     const placeholderIntro  = "lorem ipsum"
    //load google sheets data
    const sheetRangeInfo = "Info";

    const { data } = useFetch(sheetRangeInfo);
    const [introContent, setIntroContent] = useState(placeholderIntro);

    useEffect(() => {
        if (data) {
            const elementData = data ? data.values.slice(1).map(row => ({
                element: row[0],
                content: row[1],
            })) : [];

            setIntroContent (elementData[0].content);
        }
    }, [data]); */

    //animate on scroll
    useEffect(() => {
        // Register ScrollTrigger with GSAP
        gsap.registerPlugin(ScrollTrigger);
    
        if(window.innerWidth > 768){
            
            gsap.fromTo("#secProjects", 
                { y: 200 }, // from state
                {
                duration: 1, // Animation duration
                y: -50, // Move to original position
                ease: 'none', // Animation easing
                scrollTrigger: {
                    trigger: "#secProjects",
                    start: 'top 80%', // Start animation when top of item hits 80% of viewport
                    //toggleActions: 'play none none reverse', // Play animation forwards and reverse on scroll up    
                    //scrub: true, // Smooth animation
                },
                }
            );
        }
      }, []);

    return (
    <div ref={parentRef}>
        <GlitchLines parentRef={parentRef} />
        <svg className="glitchLines">
            <defs>
                <filter id="noise">
                    <feTurbulence type="fractalNoise" baseFrequency="0.05" numOctaves="5" result="noise" seed="10" />
                    <feDisplacementMap in="SourceGraphic" in2="noise" scale="10" xChannelSelector="R" yChannelSelector="G" />
                </filter>
            </defs>
            <g className="d-none d-lg-block">
            <line x1="0" y1="2%" x2="100%" y2="47%" />
            <line x1="0" y1="23%" x2="100%" y2="13%" />
            <line x1="0" y1="35%" x2="100%" y2="55%" />
            <line x1="0" y1="34%" x2="100%" y2="91%" />
            <line x1="0" y1="95%" x2="100%" y2="73%" />
            <line x1="22%" y1="100%" x2="94%" y2="0" />
            </g>
            <g className="d-lg-none">
            <line x1="0" y1="2%" x2="100%" y2="22%" />
            <line x1="0" y1="33%" x2="100%" y2="41%" />
            <line x1="0" y1="61%" x2="100%" y2="98%" />
            <line x1="0" y1="72%" x2="100%" y2="54%" />
            <line x1="0" y1="44%" x2="100%" y2="1%" />
            </g>
            
        </svg>
        <section>
            <Container fluid id="intro" className="d-flex flex-column justify-content-around">
                <Row>
                <Col className="d-flex flex-column align-items-center">
                    <h1 className={`headerText headerTextMain ${isPreloaderComplete ? 'headerTextHighlight' : ''}`}>Vernon</h1>
                    <h1 className={`headerText headerTextMain ${isPreloaderComplete ? 'headerTextHighlight' : ''}`}>Eliamani</h1>
                </Col>
                </Row>
                <Row className="d-lg-flex justify-content-lg-center align-items-lg-center introBlue">
                <Col md="auto" lg={6} className="text-nowrap d-flex flex-row align-items-center colSpace">
                    <div>
                    <h3>I Identify as a</h3>
                    <h2>Graphic Designer</h2>
                    <p id="madeinTZ">Made in Tanzania</p>
                    </div>
                    <div className="d-flex flex-column flex-md-row align-items-md-center" id="whatsThat">
                    <Link className="hover-this" to={'/faqs'}><FaQuestionCircle/><em className="d-md-none"> <br /></em> what's that?</Link>
                    </div>
                </Col>
                <Col md={8} lg={3} className="colSpace">
                <p>To inspire a uniquely African digital design landscape that works as well or better than it looks. 
                The goal is easier said than done but challenge accepted. In between, there is golf, piano, driving, 
                computer games, basketball, the great outdoors, and last but not least, Food. 
                For best results stay hydrated and sleep*</p>
                </Col>
                <Col md={4} lg={3} className="d-flex justify-content-center align-items-end justify-content-md-end colSpace">
                    <a className='hover-this' href="https://wa.me/254703928923" target="_blank" rel="noopener noreferrer">
                        <div className="d-flex flex-column align-items-end">
                            <FaWhatsapp className='iconWhatsapp'/>
                            <h6 className="text-nowrap text-end">
                                <span className="d-md-none">Tap</span>
                                <span className="d-none d-md-inline">Scan</span> TO<br />
                                WRITE TO ME ON<br />
                                WHATSAPP
                            </h6>
                        </div>
                    </a>
                    <div className="d-none d-md-block" id="introQrCode"></div>
                    </Col>
                </Row>
            </Container>
            <div className="d-none d-md-flex justify-content-center align-items-center" id="letsTalkDiv">
            <button  onClick={toggleOffcanvas} style={{border:"none", background: "none", borderRadius:"50%"}}>
                <svg className='hover-this letsTalk' id="letsTalk" viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
                <defs>
                    <path id="textPath" d="M50 50 m -40, 0 a 40,40 0 1,1 80,0 a 40,40 0 1,1 -80,0" />
                </defs>
                <text fontSize="13" fill="#0000ff">
                    <textPath xlinkHref="#textPath" startOffset="0%">
                    Click let's talk design .
                    </textPath>
                </text>
                <text fontSize="13" fill="#010101">
                    <textPath xlinkHref="#textPath" startOffset="50%">
                    Click let's talk design .
                    </textPath>
                </text>
                <animateTransform attributeName="transform" type="rotate" from="0" to="360" dur="10s"
                    repeatCount="indefinite" />
                </svg>
            </button>
            </div>
            <Services />
            <ProjectsSlider/>
            <LetsTalk />
        </section>
        <BookForm showOffcanvas={showOffcanvas} toggleOffcanvas={toggleOffcanvas} />
    </div>
    )
}

export default Home;